import svg from './row-svg/attention.svg';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function AttentionIcon(props: FixMe) {
  return <img {...props} src={svg} alt="svg" />;
}

export default AttentionIcon;
